(() => {
  const config = window.JIProductTrustCrossSell;
  if (!config || !config.productId) return;

  const init = async () => {
    const productInfo = document.querySelector('.product-info');
    if (!productInfo) return;

    const existingText = productInfo.textContent || '';
    if (existingText.includes('Deutscher Service | Antwort') || existingText.includes('Kunden kauften auch:') || productInfo.querySelector('.ji-product-trust-cross-sell')) return;

    const anchor = productInfo.querySelector('.ji-payment-methods-image')?.closest('.product-info__block-item') || productInfo.querySelector('.product-info__buy-buttons')?.closest('.product-info__block-item');
    if (!anchor) return;

    injectStyles();

    const wrapper = document.createElement('div');
    wrapper.className = 'product-info__block-item ji-product-trust-cross-sell';
    wrapper.setAttribute('data-block-type', 'ji-trust-cross-sell');
    wrapper.innerHTML = serviceMarkup() + '<hr class="product-info__separator ji-product-trust-cross-sell__separator">' + '<div class="ji-product-trust-cross-sell__recommendations" hidden></div>';
    anchor.insertAdjacentElement('afterend', wrapper);

    await loadRecommendations(wrapper.querySelector('.ji-product-trust-cross-sell__recommendations'));
  };

  const serviceMarkup = () => `
    <hr class="product-info__separator ji-product-trust-cross-sell__separator">
    <div class="product-info__block-group product-info__offer-list ji-product-trust-cross-sell__offers" data-group-type="product-info__offer-list">
      <div class="product-info__block-item" data-block-type="offer">
        <div class="offer offer--center ji-product-trust-cross-sell__offer">
          <svg aria-hidden="true" focusable="false" class="icon icon-picto-operator" width="20" height="20" viewBox="0 0 24 24"><path d="M12 3.75a7.25 7.25 0 0 0-7.25 7.25v3.25a2 2 0 0 0 2 2h1.1v-6.1H5.85A6.15 6.15 0 0 1 18.15 10.15h-2v6.1h1.1a2 2 0 0 0 2-2V11A7.25 7.25 0 0 0 12 3.75Z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="M9.4 18.4h2.95c2.25 0 3.8-1.05 4.45-2.8" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>
          <div class="prose text-sm"><p>Deutscher Service | Antwort &lt; 48 Stunden</p></div>
        </div>
      </div>
      <div class="product-info__block-item" data-block-type="offer">
        <div class="offer offer--center ji-product-trust-cross-sell__offer">
          <svg aria-hidden="true" focusable="false" class="icon icon-picto-return" width="20" height="20" viewBox="0 0 24 24"><path d="M8 7.5H5.25V4.75" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.55 7.35A7.8 7.8 0 1 1 4.25 12" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>
          <div class="prose text-sm"><p>60 Tage Rückgabe | Kostenloser Rückversand</p></div>
        </div>
      </div>
    </div>`;

  const loadRecommendations = async (container) => {
    try {
      const response = await fetch(`/recommendations/products.json?product_id=${encodeURIComponent(config.productId)}&limit=5&intent=complementary`, { credentials: 'same-origin' });
      if (!response.ok) return;
      const data = await response.json();
      const products = Array.isArray(data.products) ? data.products : [];
      if (!products.length) return;

      container.innerHTML = `
        <div class="product-info__complementary-products v-stack gap-3 sm:gap-4">
          <div class="h-stack justify-between gap-4"><p>Kunden kauften auch:</p></div>
          <div class="horizontal-product-list border divide-y rounded-xs">
            ${products.map(productCard).join('')}
          </div>
        </div>`;
      container.hidden = false;
      bindAddButtons(container);
    } catch (error) {
      console.warn('JI cross-sell recommendations could not be loaded', error);
    }
  };

  const productCard = (product) => {
    const variant = (product.variants || []).find((item) => item.available) || (product.variants || [])[0];
    const image = product.featured_image || product.images?.[0] || '';
    const imageMarkup = image ? `<a href="${escapeHtml(product.url)}"><img class="horizontal-product__image rounded-xs" src="${escapeHtml(image)}" alt="${escapeHtml(product.title)}" loading="lazy" width="80"></a>` : '';
    const button = variant ? `<button type="button" class="button button--sm button--subdued ji-product-trust-cross-sell__add" data-variant-id="${variant.id}">+ Hinzufügen</button>` : '';

    return `
      <div class="horizontal-product rounded-xs snap-start" data-product-handle="${escapeHtml(product.handle || '')}">
        ${imageMarkup}
        <div class="horizontal-product__info">
          <div class="v-stack gap-0.5">
            <a href="${escapeHtml(product.url)}" class="text-sm bold"><span class="reversed-link hover:show">${escapeHtml(product.title)}</span></a>
            <span class="text-sm text-subdued">ab ${formatMoney(product.price)}</span>
          </div>
          <div class="horizontal-product__cta">${button}</div>
        </div>
      </div>`;
  };

  const bindAddButtons = (container) => {
    container.querySelectorAll('.ji-product-trust-cross-sell__add').forEach((button) => {
      button.addEventListener('click', async () => {
        if (button.disabled) return;
        const original = button.textContent;
        button.disabled = true;
        button.textContent = '...';
        try {
          const response = await fetch(config.cartAddUrl || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: Number(button.dataset.variantId), quantity: 1 })
          });
          if (!response.ok) throw new Error('Cart add failed');
          button.textContent = 'Hinzugefügt';
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
          setTimeout(() => { button.disabled = false; button.textContent = original; }, 1800);
        } catch (error) {
          button.disabled = false;
          button.textContent = original;
          console.warn(error);
        }
      });
    });
  };

  const formatMoney = (value) => {
    const cents = Number(value || 0);
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  };

  const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char]));

  const injectStyles = () => {
    if (document.getElementById('ji-product-trust-cross-sell-style')) return;
    const style = document.createElement('style');
    style.id = 'ji-product-trust-cross-sell-style';
    style.textContent = `
      .ji-product-trust-cross-sell__offer { background: #f0f0f0; color: #1e1f1f; }
      .ji-product-trust-cross-sell__offer .prose p { margin: 0; }
      .ji-product-trust-cross-sell .horizontal-product__image { object-fit: contain; background: #fff; }
      .ji-product-trust-cross-sell__add { white-space: nowrap; }
    `;
    document.head.appendChild(style);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
